// extracted by mini-css-extract-plugin
export default {"drawer":"add-edit-new-holiday_drawer__xX-tG","footerWrapper":"add-edit-new-holiday_footerWrapper__bvGrA","footerBackButton":"add-edit-new-holiday_footerBackButton__b3sM2"};